import { useContext, useDeferredValue, useEffect, useState } from 'react';
import { faMagnifyingGlass } from '@fortawesome/pro-regular-svg-icons';
import { SwitchThemeContext, TextField } from '@tryhackme/thm-ui-components';
import { useParams } from 'react-router-dom';
import { ThemeColorMode } from 'src/common/enums';
import { useFetchCategoriesQuery } from 'src/features/manage-room/manage-room.slice';
import { store } from 'src/app/store';
import { setCategories } from 'src/app/reducers/manage-room.reducer';
import { useAppSelector } from 'src/app/hooks';
import { StyledTagsHeading } from '../../categories-tab.styles';
import { CategoryTagsCard } from '../category-tags-card';
import { StyledBrowseCategoriesWrapper, StyledSearchIcon } from './browse-categories.styles';
export const BrowseCategories = () => {
  const {
    roomCode
  } = useParams();
  const {
    theme
  } = useContext(SwitchThemeContext);
  const isDarkMode = theme === ThemeColorMode.DARK;
  const categories = useAppSelector(state => state.manageRoom.generalCategories.categories);
  const [searchText, setSearchText] = useState<string>('');
  const deferredSearchText = useDeferredValue(searchText);
  const {
    data,
    isFetching
  } = useFetchCategoriesQuery({
    roomCode: (roomCode as string),
    searchText: deferredSearchText
  });
  useEffect(() => {
    store.dispatch(setCategories(data?.data ?? []));
  }, [data?.data, isFetching]);
  const handleSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (!/^[\d A-Za-z-]+$/.test(e.target.value) && !/^$/.test(e.target.value)) return;
    setSearchText(e.target.value);
  };
  return <div data-sentry-component="BrowseCategories" data-sentry-source-file="browse-categories.tsx">
      <StyledTagsHeading data-sentry-element="StyledTagsHeading" data-sentry-source-file="browse-categories.tsx">Browse MITRE categories</StyledTagsHeading>
      <TextField variant="input" data-testid="search-topic-input" placeholder="Search a topic or ID" leftAdornment={<StyledSearchIcon isDarkMode={isDarkMode} icon={faMagnifyingGlass} />} value={searchText} onChange={handleSearch} data-sentry-element="TextField" data-sentry-source-file="browse-categories.tsx" />

      <StyledBrowseCategoriesWrapper data-sentry-element="StyledBrowseCategoriesWrapper" data-sentry-source-file="browse-categories.tsx">
        {categories.map(category => <CategoryTagsCard key={category._id} category={category} />)}
      </StyledBrowseCategoriesWrapper>
    </div>;
};